import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { GiSoundWaves } from 'react-icons/gi';
import { FaBoreHole, FaCompassDrafting } from 'react-icons/fa6';
import { 
  BsBuilding 
} from 'react-icons/bs';

// Import images - Place your images in src/assets/images/ folder
// Images will be displayed if they exist, otherwise only icons will show
let surveyImage, drillingImage, recordingImage, projectImage;

try {
  surveyImage = require('../../assets/images/survey-operations.png');
} catch (e) {
  surveyImage = null;
}

try {
  drillingImage = require('../../assets/images/drilling-operations.png');
} catch (e) {
  drillingImage = null;
}

try {
  recordingImage = require('../../assets/images/recording-operations.png');
} catch (e) {
  recordingImage = null;
}

try {
  projectImage = require('../../assets/images/project-management.png');
} catch (e) {
  projectImage = null;
}

const SolutionsSection = () => {
  const { t, tArray } = useLanguage();
  
  const icons = [
    <FaCompassDrafting />,
    <FaBoreHole />,
    <GiSoundWaves />,
    <BsBuilding />
  ];

  const images = [
    surveyImage,
    drillingImage,
    recordingImage,
    projectImage
  ];
  
  const solutionsData = tArray('solutions.items');
  const solutions = solutionsData.map((solution, index) => ({
    icon: icons[index],
    image: images[index],
    title: solution.title,
    description: solution.description
  }));

  return (
    <section id="solutions" className="landing-section">
      <div className="container-landing">
        <div className="text-center">
          <h2 className="section-title">{t('solutions.title')}</h2>
          <p className="section-subtitle">
            {t('solutions.subtitle')}
          </p>
        </div>

        <div className="solutions-grid">
          {solutions.map((solution, index) => (
            <div key={index} className="solution-card">
              <div className="solution-image">
                <div className="solution-icon">
                  {solution.icon}
                </div>
                {solution.image && (
                  <img 
                    src={solution.image} 
                    alt={solution.title}
                    className="solution-photo"
                  />
                )}
              </div>
              <div className="solution-content">
                <h3 className="solution-title">{solution.title}</h3>
                <p className="solution-description">{solution.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
